import {
  FetchNextPageOptions,
  InfiniteData,
  InfiniteQueryObserverResult,
} from '@tanstack/react-query';

import { Pagination } from '~services/pagination';

export const INFINITE_QUERY_PAGINATION_LIMIT = 10;

export const RARELY_CHANGED_DATA_STALE_TIME_IN_MS = 5 * 60 * 1000;

// Root key: creating or editing a payment term invalidates this prefix for every company.
export const PAYMENT_TERMS_QUERY_KEY = 'paymentTerms';

// Root key: editing or deleting a tax rate schedule invalidates this prefix for every company.
export const TAX_RATE_SCHEDULE_QUERY_KEY = 'taxRateSchedule';

// Root key: saving or a real-time update of an invoice's line items invalidates its prefix.
export const PAY_COMMISSION_PRESENTATION_QUERY_KEY = 'payCommissionPresentation';

// Stepping through the onboarding wizard remounts its queries per step; edits invalidate them.
export const COMPANY_ONBOARDING_STALE_TIME_IN_MS = 30 * 1000;

export enum InfiniteQueryFetchReason {
  SEARCH_VALUE = 'search_value',
  INFINITE_SCROLL = 'infinite_scroll',
}

export type InfiniteQueryOption = { label: string; value: string };

export type InfiniteQueryParamsState = {
  shouldFetch: boolean;
  filters: { query: string };
  pagination?: Pagination & { hasMore: boolean };
};

export type InfiniteQueryBaseParams = {
  'page[after]'?: string;
  'page[limit]'?: number;
  'search[query]'?: string;
};

export interface InfiniteQuery {
  clear: () => void;
  data: InfiniteQueryOption[];
  fetch: (searchQuery: string) => void;
  fetchMore:
    | ((
        options?: FetchNextPageOptions | undefined,
      ) => Promise<
        InfiniteQueryObserverResult<InfiniteData<InfiniteQueryOption[], unknown>, Error>
      >)
    | undefined;
  fetchReason?: InfiniteQueryFetchReason;
  isDummyQuery: boolean;
}
